import React, { Component } from 'react';
import { Icon, Popover, Select } from 'antd';
import { connect } from 'react-redux';
import { debounce } from '../../../../shared/helpers';
import { getBikesForPartExRequest } from '../redux/actions/get_bikes_for_par_ex.actions';
import { getBikeBrandsRequest } from '../redux/actions/get_bike_brands.actions';

const { Option } = Select;

const hintContent = {
    part_ex: 'From the list, please select a bike that customer interested in',
};

const formFieldStyle = {
    mainContainer: { marginTop: 5 },
    fieldStyle: { width: 428 },
    container: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' },
    wrapper: { width: '100%' },
    hintContainer: { display: 'flex', alignItems: 'center', marginTop: 7 },
    hintIconStyle: { marginLeft: 10, fontSize: 18 },
    errorIconStyle: { margin: '0 5px' },
};

class PartExInfo extends Component {
    handleChange = (value, path) => {
        this.props.Lead_create_data.set({ [path]: value });
        this.forceUpdate();
    };

    handleSearch = (searchText) => {
        this.runFetch({ searchText, limit: 30 }, this.props.getBikesForPartExRequest);
    };

    requestData = (params, callback) => callback(params);

    runFetch = debounce(this.requestData, 500);

    render() {
        const { bikes_for_part_ex, brands } = this.props;
        const data = this.props.Lead_create_data;
        data.errors = {};
        data.validateSync();

        return (
            <div style={{ maxWidth: 470, marginBottom: 20 }} ref={this.formRef}>
                <div style={formFieldStyle.mainContainer}>
                    <h5>Bike, that customer interested in...(Search bike by brand, please)</h5>
                    <div style={formFieldStyle.container}>
                        <div style={formFieldStyle.wrapper}>
                            <Select
                                db_key_select="part_ex.ref_bike_inventory"
                                defaultValue={data.part_ex.part_ex_bike && data.part_ex.part_ex_bike.toJSON()}
                                showSearch
                                allowClear
                                style={formFieldStyle.fieldStyle}
                                placeholder="Select model"
                                onSearch={(searchText) => this.runFetch({ searchText, brandId: brands.data[0]._id }, this.props.getBikesForPartExRequest)}
                                onChange={(value) => this.handleChange(value, 'part_ex.ref_bike_inventory')}
                                optionFilterProp="children"
                                filterOption={() => true}
                            >
                                <Option key="not yet decided" value={undefined}>Not yet decided</Option>

                                {bikes_for_part_ex.data.map((bike) => (
                                    bike.ref_bike_brand?.name && bike.ref_bike_model?.name &&
                                        <Option key={bike._id} value={bike._id}>
                                            {bike.ref_bike_brand.name}
                                            {' '}
                                            {bike.ref_bike_model.name}
                                            {' '}
                                            (
                                            {bike.vrm}
                                            )
                                        </Option>
                                ))}
                            </Select>
                            <span
                                style={{
                                    display: 'block',
                                    color: 'red',
                                    visibility: data.errors['ref_bike_lead.part_ex_bike'] ? 'visible' : 'hidden',
                                }}
                            >
                                <Icon type="warning" style={formFieldStyle.errorIconStyle} />
                                {data.errors['part_ex.part_ex_bike'] && data.errors['part_ex.part_ex_bike'].message}
                            </span>
                        </div>


                        <div style={formFieldStyle.hintContainer}>
                            <Popover content={hintContent.part_ex} trigger="click">
                                <Icon type="question-circle" theme="twoTone" style={formFieldStyle.hintIconStyle} />
                            </Popover>
                        </div>
                    </div>
                </div>

            </div>


        );
    }
}

const mapStateToProps = (state) => {
    const {
        brands, models, variants, bikes_for_part_ex, bike_info_by_vrm,
    } = state.Leads.Lead_create;
    return {
        brands, models, variants, bike_info_by_vrm, bikes_for_part_ex,
    };
};


export default connect(mapStateToProps, { getBikeBrandsRequest, getBikesForPartExRequest })(PartExInfo);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/components/PartExInfo.js